import { ImageUrlsResized } from "./images.model";
import { League } from "./league.model";

export enum EventTypeCode {
  Individual = "indvidual",
  TeamChampionship = "team_championship",
  TeamCup = "team_cup"
}

export type SportEventStatusCode = "registration" | "started" | "registration end" | "inprogress" | "end";

export type RegistrationStatusCode = "apply" | "modifiable" | "finished";

export interface SportEventStatus {
  code: SportEventStatusCode;
  name: string;
  description: string;
}

export interface SportEventRegistrationStatus {
  code: RegistrationStatusCode;
  name: string;
  description: string;
}

export interface SportEventBase {
  id: number;
  name: string;
}

export interface SportEvent extends SportEventBase {
  description: string;
  min_player_num: number;
  max_player_num: number;
  entry_fee: number;
  entry_currency: string;
  start_time: string;
  end_time: string;
  reg_start_time: string;
  reg_end_time: string;
  registration_status: SportEventRegistrationStatus;
  status: SportEventStatus;
  image_url: string;
  image_urls_resized: ImageUrlsResized;
  leagues?: Array<League>;
  organizer: {
    email: string;
    phone: string;
    name: string;
  };
}
